export const notFound = {
  text: '404 - These are not the pages that you are looking for.',
  action: 'Back to Home',
  goBack: 'Go Back'
};
